import { format } from 'date-fns';
import { toCsv } from '@/utils/reportCsv';
import type { AuditTrailRow } from '@/utils/AuditTrail/types';

export const AUDIT_TRAIL_CSV_HEADERS = ['Employee', 'Week Ending', 'Department', 'Status', 'Last Event', 'Total Hours'];

export const buildAuditTrailCsv = (rows: AuditTrailRow[]): string =>
  toCsv(
    AUDIT_TRAIL_CSV_HEADERS,
    rows.map((r) => [
      r.employeeName,
      format(r.weekEnding, 'dd/MM/yyyy'),
      r.department,
      r.status.charAt(0).toUpperCase() + r.status.slice(1),
      r.lastEvent,
      `${r.totalHours}`,
    ]),
  );
